<template>
    <div class="game-wrapper">
        <div class="taskbar">
            <div class="backToHome">
                <router-link to="/">X</router-link>
            </div>

        </div>

        <div class="game">
            <h2>{{ foundGame.name }}</h2>
            <iframe :src="foundGame.iframeSrc" frameborder="0"></iframe>
        </div>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    export default {
        name: 'Game',

        props: {
            gameID: {
                default: null,
                type: String
            }
        },

        computed: {
            foundGame()
            {
                return this.$store.getters[ 'game/find' ]( this.gameID )[0];
            }
        }
    };
</script>
